module.exports = __webpack_public_path__ + "img/18.2cb08512.jpg";